var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "widget-height" },
    [
      _vm._m(0),
      _c(
        "div",
        {
          staticClass: "content",
          class: { "fix-height": _vm.isCombo, "single-height": !_vm.isCombo },
        },
        [
          _vm.upcomingRegistrations.length > 0
            ? _c(
                "div",
                _vm._l(
                  _vm.upcomingRegistrations,
                  function (registration, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "upcoming-regns" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "row col-xs-12 notification-date-css",
                            class: _vm.isCombo ? "pt-8" : "",
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("UTCDate")(
                                    registration.date,
                                    "MMM DD, YYYY"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                        _vm._l(
                          registration.registrations,
                          function (registrationIds) {
                            return _c(
                              "div",
                              { key: registrationIds, staticClass: "row" },
                              [_vm._m(1, true)]
                            )
                          }
                        ),
                      ],
                      2
                    )
                  }
                ),
                0
              )
            : _vm._e(),
          _vm.upcomingRegistrations.length === 0
            ? _c("div", { staticClass: "pt-27" }, [
                _c("span", { staticClass: "no-events" }, [
                  _vm._v("No upcoming events"),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm.dashboardRecordsFlag
        ? _c("registration-details-popup", {
            attrs: {
              permissions: _vm.permissions,
              dashboardRecordsFlag: _vm.dashboardRecordsFlag,
              dataRow: _vm.activeRegistration,
              reportFlag: true,
            },
            on: { dashboardWidgets: _vm.dashboardWidgets },
          })
        : _vm._e(),
      _c("permission-access-modal"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _c("img", {
          staticClass: "calender_icon",
          attrs: { src: "/static/images/icons/calender_icon.svg" },
        }),
        _c("span", [_vm._v("Upcoming Events")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-xs-12 reg-pd" }, [
      _c("img", {
        staticClass: "alert-triangle",
        attrs: { src: "/static/images/icons/alert_triangle.svg" },
      }),
      _c("span", { staticClass: "reg-expr" }, [_vm._v("Registration expires")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }